// 공통 API 베이스 URL 계산
// 환경변수(REACT_APP_MANUALS_API_BASE_URL)만 사용합니다.
const normalize = (s = '') => s.replace(/\/+$/, '');

const fromEnv = normalize(process.env.REACT_APP_MANUALS_API_BASE_URL || '');

export default fromEnv;
